
import { Link } from 'react-router-dom';
import Button from '../../../components/base/Button';

export default function AboutCTA() {
  return (
    <section className="py-20 bg-red-600">
      <div className="container mx-auto px-4 text-center">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl font-bold text-white mb-6">
            Ready to Protect Your Property?
          </h2>
          <p className="text-xl text-red-100 mb-8 leading-relaxed">
            Partner with FlameGuardQA for comprehensive fire safety solutions that meet 
            QCDD standards and exceed your expectations.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/contact">
              <Button className="bg-white text-red-600 hover:bg-gray-100 whitespace-nowrap">
                Get a Free Quote
                <div className="w-4 h-4 flex items-center justify-center ml-2">
                  <i className="ri-arrow-right-line"></i>
                </div>
              </Button>
            </Link>
            <Link to="/services">
              <Button className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-red-600 whitespace-nowrap">
                View Our Services
                <div className="w-4 h-4 flex items-center justify-center ml-2">
                  <i className="ri-service-line"></i>
                </div>
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}